import {
    AssignmentBudgetFilters,
    AssignmentFilter,
    AssignmentVisualizationsFilters,
    ClientFilter,
    defaultAssignmentBudgetFilter,
    defaultAssignmentFilter,
    defaultAssignmentVisualizationsFilters,
    defaultClientFilters,
    defaultEntryFilters,
    defaultInvoicingFilters,
    defaultStaffFilters,
    InvoicingFilters,
    StaffFilter,
} from "@app/constants/filters.defaults.tsx";
import { EntryFiltersModel } from "@app/data-hooks/use-entries-data.ts";
import { PersistentStore } from "bi-lib";

export const assignmentFiltersStore = new PersistentStore<AssignmentFilter>(
    "assignmentFilters",
    defaultAssignmentFilter,
);

const assignmentBudgetFiltersStoreMap = new Map<number, PersistentStore<AssignmentBudgetFilters>>();
export const assignmentBudgetFiltersStore = (assignmentId: number) => {
    let store = assignmentBudgetFiltersStoreMap.get(assignmentId);
    if (store) {
        return store;
    }
    store = new PersistentStore<AssignmentBudgetFilters>(
        `assignmentBudgetFilters-${assignmentId}`,
        defaultAssignmentBudgetFilter,
    );
    assignmentBudgetFiltersStoreMap.set(assignmentId, store);
    return store;
};

const assignmentVisualizationsFiltersStoreMap = new Map<number, PersistentStore<AssignmentVisualizationsFilters>>();
export const assignmentVisualizationsFiltersStore = (assignmentId: number) => {
    let store = assignmentVisualizationsFiltersStoreMap.get(assignmentId);
    if (store) {
        return store;
    }
    store = new PersistentStore<AssignmentVisualizationsFilters>(
        `assignmentVisualizationsFilters-${assignmentId}`,
        defaultAssignmentVisualizationsFilters,
    );
    assignmentVisualizationsFiltersStoreMap.set(assignmentId, store);
    return store;
};

export const clientFiltersStore = new PersistentStore<ClientFilter>("clientFilters", defaultClientFilters);

export const entryFiltersStore = new PersistentStore<EntryFiltersModel>("entryFilters", defaultEntryFilters);
entryFiltersStore.setState = entryFiltersStore.setState.bind(entryFiltersStore);

export const invoicingFiltersStore = new PersistentStore<InvoicingFilters>("invoicingFilters", defaultInvoicingFilters);

export const staffFiltersStore = new PersistentStore<StaffFilter>("staffFilters", defaultStaffFilters);
